import { paramCase } from "change-case";
import * as icons from "./index";

const rest: any = {};
Object.keys(icons).forEach(
  (key) => (rest[paramCase(key)] = icons[key as keyof typeof icons]),
);
export const solid = {
  ...rest,
  "broadcast-tower": icons.BroadcastTower,
  "check-circle": icons.CheckCircle,
  "draw-polygon": icons.DrawPolygon,
  "droplet-percent": icons.DropletPercent,
  "faucet-drip": icons.FaucetDrip,
  "flag-usa": icons.FlagUsa,
  "horizontal-rule": icons.HorizontalRule,
  "house-flood": icons.HouseFlood,
  "line-string": icons.WaveSin,
  "map-marked-alt": icons.MapMarkedAlt,
  "map-marker-alt": icons.MapMarkerAlt,
  "map-marker-times": icons.MapMarkerTimes,
  "map-marker": icons.MapMarker,
  "map-pin": icons.MapPin,
  nuclear: icons.RadiationAlt,
  "route-interstate": icons.RouteInterstate,
  "snow-blowing": icons.SnowBlowing,
  "sun-bright": icons.SunBright,
  "temperature-high": icons.TemperatureHigh,
  "thumbs-down": icons.ThumbsDown,
  "thumbs-up": icons.ThumbsUp,
  biohazard: icons.Biohazard,
  brownfield: icons.Brownfield,
  chevron: icons.Chevron,
  circle: icons.Circle,
  city: icons.City,
  crosshairs: icons.Crosshairs,
  digging: icons.Digging,
  eye: icons.Eye,
  "heat-waves": icons.SunHaze,
  house: icons.House,
  hurricane: icons.Hurricane,
  hvline: icons.Hvline,
  landslides: icons.Landslides,
  landfill: icons.Landfill,
  link: icons.Link,
  location: icons.Location,
  pen: icons.Pen,
  pipeline: icons.Pipeline,
  podcast: icons.Podcast,
  radiation: icons.Radiation,
  "riverine-floods": icons.WaterArrowUp,
  route: icons.Route,
  smog: icons.Smog,
  square: icons.Square,
  tornado: icons.Tornado,
  tornadoes: icons.Tornado,
  usps: icons.Usps,
  well: icons.Well,
  wind: icons.Wind,
  parks: icons.Parks,
  "ev-charging-station": icons.EVChargingStation,
};
